/**
 * Which competitions are ANNOUNCED — readable by anyone, without being the
 * competition's staff (docs/spec/05-competitions-core.md, "Who can read a
 * draft"; docs/spec/02b-shared-packages.md, "Competition visibility").
 *
 * A whitelist, not "everything but a draft": a status added later starts out
 * hidden until someone decides it is public — the same choice the event's
 * `published` / `closed` / `cancelled` rule made. `closing` is in it because a
 * competition passes through it on every close; dropping it would blank the
 * spectator board for the seconds the result snapshot takes.
 *
 * firestore.rules carries the same three values by hand in the competition
 * document's auth-free `allow get, list` (rules cannot import);
 * tests/gates/competitionVisibilityRules.test.js holds the two together.
 *
 * Callers: the client's non-staff list query (`competitionsListQuery`,
 * apps/web/src/utils/competitionFetch.js), and two server readers that go
 * through the Admin SDK and so must apply the rule themselves: the `gymPage`
 * link preview (apps/functions/src/hosting.js) and the world-readable platform
 * calendar index (`compEntry`, apps/functions/publicCalendar.js).
 */
export const PUBLIC_COMPETITION_STATUSES = Object.freeze(["active", "closing", "closed"]);

/**
 * @param {object|null|undefined} comp  a competition document's data
 * @returns {boolean} true when anyone may read it; false for a draft, an
 *   unknown or missing status, and anything that is not a document
 */
export function isPublicCompetition(comp) {
  if (!comp || typeof comp !== "object") return false;
  return PUBLIC_COMPETITION_STATUSES.includes(comp.status);
}
